import React, { Component } from "react";

import FooterComponent from "./FooterComponent";

export default class Footer extends Component {
  render() {
    return <FooterComponent {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Footer/index.js